export default {"src":"/_next/static/media/icon-3.189db36c.svg","height":90,"width":90,"blurWidth":0,"blurHeight":0};